import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useState } from "react";
import { FileButton, UnstyledButton } from "@mantine/core";
import { faPaperclip, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { useEmrContext } from "@/hooks/emr-context";
import { useUploadAttachments } from "@/hooks/attachment";
import { useComposerStore } from "@/stores/composers";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { ComposerShell } from "./composer-shell";
/** Attachment composer: pick photos, audio or documents and upload them. */
export function AttachmentComposerBody(_ref) {
  var _composer$accept;
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var _useState = useState([]),
    files = _useState[0],
    setFiles = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var upload = useUploadAttachments(patientUid);
  var accept = (_composer$accept = composer.accept) !== null && _composer$accept !== void 0 ? _composer$accept : "image/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx";
  var addFiles = function addFiles(picked) {
    trackEvent(ANALYTICS_EVENTS.ATTACHMENT_PICK);
    setFiles(function (prev) {
      return [].concat(_toConsumableArray(prev), _toConsumableArray(picked));
    });
  };
  var removeFile = function removeFile(index) {
    trackEvent(ANALYTICS_EVENTS.ATTACHMENT_REMOVE, {
      index: index
    });
    setFiles(function (prev) {
      return prev.filter(function (_, item) {
        return item !== index;
      });
    });
  };
  var send = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setError(null);
            _context.p = 1;
            _context.n = 2;
            return upload.mutateAsync(files);
          case 2:
            close(composer.id);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            setError(t("attachment_upload_failed", {
              defaultValue: "Could not upload. Please try again."
            }));
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function send() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: composer.title,
    subtitle: composer.subtitle,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-cancel-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CANCEL, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "composer-save-".concat(composer.id),
      loading: upload.isLoading,
      disabled: !files.length,
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_SAVE, {
          composerId: composer.id
        });
        void send();
      }
    }, t("upload", {
      defaultValue: "Upload"
    })))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement(FileButton, {
    multiple: true,
    accept: accept,
    onChange: addFiles
  }, function (props) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      variant: "secondary",
      size: "sm",
      leftIcon: faPaperclip,
      "data-testid": "attachment-pick"
    }), t("choose_files", {
      defaultValue: "Choose files"
    }));
  }), files.length ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, files.map(function (file, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(file.name, "-").concat(index),
      className: "flex items-center justify-between gap-3 rounded-sds-200 border border-sds-base-default px-3 py-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "truncate text-style-body-small text-sds-base-default"
    }, file.name), /*#__PURE__*/React.createElement(UnstyledButton, {
      type: "button",
      "aria-label": t("remove", {
        defaultValue: "Remove"
      }),
      "data-testid": "attachment-remove-".concat(index),
      onClick: function onClick() {
        return removeFile(index);
      },
      className: "text-sds-base-tertiary transition-colors hover:text-sds-urgent-default"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faXmark,
      className: "h-4 w-4"
    })));
  })) : /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-tertiary"
  }, t("attachment_hint", {
    defaultValue: "Add {{type}}.",
    type: composer.title.toLowerCase()
  })), error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-urgent-secondary"
  }, error) : null));
}